<view-file *ngIf="documentSearchParams.identifierId" [parentCategory]="'Servicer'" [searchParams]="documentSearchParams"
    [title]="'Documents'" [tabKey]="'documents-tab'"></view-file>